import axios from 'axios'
import { useAlert } from '@/composables/useAlert'
import { ref } from 'vue'
import { useProgress } from '@marcoschulte/vue3-progress'

const progresses = ref([])

const ApiBudgety = axios.create({
  baseURL: process.env.VUE_APP_API_BUDGETY_HOST,
})

let isRefreshing = false
let failedQueue = []
let isToastShown = false

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

ApiBudgety.interceptors.response.use(
  function (response) {
    progresses.value.pop()?.finish()
    return response
  },
  function (error) {
    progresses.value.pop()?.finish()
    if (error.message && error.message.includes('Network Error')) {
      useAlert().alert({
        title: 'Sin conexión',
        text: 'Lo sentimos, no se ha logrado establecer conexión con el servidor. Intente en un momento.',
        icon: 'warning',
      })
      return Promise.reject(error)
    }

    if (typeof error.response !== 'undefined') {
      const isPublicTvEndpoint = error.config && error.config.url && (error.config.url.includes('/verify') || error.config.url.includes('/data'))

      if (error.response.status === 401 && !isPublicTvEndpoint) {
        const originalRequest = error.config

        if (!originalRequest._retry) {
          originalRequest._retry = true

          if (isRefreshing) {
            return new Promise(function (resolve, reject) {
              failedQueue.push({ resolve, reject })
            })
              .then(token => {
                originalRequest.headers['Authorization'] = 'Bearer ' + token
                return ApiBudgety(originalRequest)
              })
              .catch(err => {
                return Promise.reject(err)
              })
          }

          isRefreshing = true

          return new Promise(async (resolve, reject) => {
            try {
              let currentUser = JSON.parse(localStorage.currentUser || '{}')
              if (!currentUser || !currentUser.token) {
                throw new Error('No current user token')
              }

              // Renovar token automáticamente en segundo plano (sin forzar cierre de sesión)
              const refreshResponse = await axios.post(
                process.env.VUE_APP_API_BUDGETY_HOST + 'Login/RefreshToken',
                { token: currentUser.token },
                {
                  headers: {
                    ApiKey: process.env.VUE_APP_API_BUDGETY_KEY,
                    'Content-Type': 'application/json',
                  },
                }
              )

              if (refreshResponse.data && refreshResponse.data.token) {
                const newToken = refreshResponse.data.token
                currentUser.token = newToken
                localStorage.currentUser = JSON.stringify(currentUser)

                originalRequest.headers['Authorization'] = 'Bearer ' + newToken
                processQueue(null, newToken)
                resolve(ApiBudgety(originalRequest))
              } else {
                throw new Error('Invalid refresh token response')
              }
            } catch (refreshErr) {
              processQueue(refreshErr, null)
              reject(refreshErr)
            } finally {
              isRefreshing = false
            }
          })
        }
      } else if (error.response.status === 403) {
        if (!isToastShown) {
          const store = require('@/store').default
          store.dispatch('addToasts', {
            title: 'Permisos',
            content: 'Su usuario no cuenta con accesos a la funcionalidad; contacte con su administrador.',
          })
          isToastShown = true
          setTimeout(() => {
            isToastShown = false
          }, 3000)
        }
      }
    }

    return Promise.reject(error)
  }
)

ApiBudgety.interceptors.request.use(config => {
  progresses.value.pop()?.finish()
  //config.headers['Content-Security-Policy'] = "default-src 'self'; script-src 'self'; style-src 'self'; font-src 'self'; img-src 'self'; frame-src 'self'";
  //config.headers['X-Frame-Options'] = 'DENY';
  //config.headers['X-Content-Type-Options'] = 'nosniff';
  config.headers['ApiKey'] = process.env.VUE_APP_API_BUDGETY_KEY
  try {
    progresses.value.push(useProgress().start())
    let currentUser = JSON.parse(localStorage.currentUser)
    if (currentUser.token) {
      config.headers['Authorization'] = 'Bearer ' + currentUser.token
    }
  } catch (error) {}
  return config
})

export default ApiBudgety
